import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UsuarioService } from 'src/app/access-control/services/usuario.service';
import { GobiernoUser } from '../../interfaces/user.interface';

@Component({
    selector: 'app-ver-usuario-modal',
    templateUrl: './ver-usuario-modal.component.html',
    styleUrls: ['./ver-usuario-modal.component.css'],
})
export class VerUsuarioModalComponent implements OnInit {
    @Input() public usuario!: GobiernoUser;

    public constructor(
        public activeModal: NgbActiveModal,
        private usuarioService: UsuarioService
    ) {}

    public ngOnInit(): void {
        this.usuarioService.getUsuario(this.usuario.id).subscribe((usuario) => {
            this.usuario = usuario;
        });
    }

    public get nombreCompleto(): string {
        return `${this.usuario?.nombre ?? ''} ${this.usuario?.apellido ?? ''}`.trim();
    }

    public get nombresRoles(): string {
        return (
            this.usuario?.roles?.map((rol) => rol.nombre).join(', ') || 'N/A'
        );
    }

    public get fechaEstimadaInactivacion(): string | null {
        return this.usuario?.roles?.[0]?.UsuarioRol?.fechaFin ?? null;
    }

    public cerrar(): void {
        this.activeModal.close();
    }
}
